import * as React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';

import { Button, Intent } from '@blueprintjs/core';
import type { ButtonProps } from '@blueprintjs/core';
import { faCopy } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { message } from 'antd';

export interface CopyToClipboardButtonProps {
  buttonProps?: ButtonProps;
  children?: React.ReactNode;
  copyData: string;
}

export const CopyToClipboardButton: React.FC<CopyToClipboardButtonProps> = ({
  buttonProps,
  copyData,
  children,
}) => {
  const onCopy = () => message.success('Copied to clipboard!', 1);

  return (
    <CopyToClipboard
      text={copyData ? copyData : children?.toString() || ''}
      onCopy={onCopy}
    >
      <Button
        outlined
        icon={<FontAwesomeIcon icon={faCopy} />}
        intent={Intent.PRIMARY}
        {...buttonProps}
      >
        {children?.toString()}
      </Button>
    </CopyToClipboard>
  );
};
